/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  TypeClientEnum,
  typeClientObj,
} from "../../assets/utils/enums/project";
import { useFormValidation } from "../../assets/utils/hooks/useFormsValidation";
import { validateCompany } from "../../assets/utils/validation/form/validator-company";
import { useNavigate, useParams } from "react-router-dom";
import getData from "../../api/project-request";
import {
  API_URL_COMPANY,
  API_URL_CONTACT,
} from "../../constants";
import { ValidationFormsModeEnum } from "../../assets/utils/validation/form/types";
import toast from "react-hot-toast";
import CustomToast from "../../components/ui/custom-toast";
import { ToastTypeEnum } from "../../assets/utils/enums/toast";
import AppLayout, { MainBody } from "../../components/layout/app/layout";
import Headline from "../../components/ui/headline";
import { HeadlineTypeEnum } from "../../assets/utils/enums/headline";
import { ThemeTypeEnum } from "../../assets/utils/validation/types";
import { BodyDiv } from "../../components/components-style";
import {
  CaptionText,
  LittleSubHeadline,
  TextBody,
} from "../../components/typography";
import Input from "../../components/ui/inputs";
import { GeneralItemBlock } from "../project/add";
import { Button } from "../../components/ui/button";
import { COLORS } from "../../assets/utils/enums/colors";
import { authFetch } from "../../api/authFetch";

export default function UpdateCompanyPage() {
  const { id } = useParams<{ id: string }>();
  const [name, setName] = useState<string>("");
  const [site, setSite] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [responsibleContact, setResponsibleContact] = useState<string>("");
  const [type, setType] = useState<string>(TypeClientEnum.POTENTIAL_CLIENT);

  const [filterResponsible, setFilterResponsible] = useState<
    { fullName: string; email: string }[]
  >([]);
  const [initialData, setInitialData] = useState<any>(null);
  const [isChanged, setIsChanged] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { errors, validate } = useFormValidation(validateCompany);
  const navigate = useNavigate();

  const getResponsibleUsers = async () => {
    const data = await getData(
      `${API_URL_CONTACT}/search?query=${responsibleContact}&companyId=${id}`
    );
    setFilterResponsible(data.slice(0, 4));
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const data = await getData(`${API_URL_COMPANY}/company-details/${id}`);
        if (!data) return;

        const normalized = {
          name: data.name || "",
          type:
            (data.customerType as TypeClientEnum) ||
            TypeClientEnum.POTENTIAL_CLIENT,
          site: data.siteLink,
          description: data.description,
          responsibleContact: data.contactEmail,
        };
        setName(normalized.name);
        setType(normalized.type);
        setSite(normalized.site);
        setDescription(normalized.description);
        setResponsibleContact(normalized.responsibleContact);

        setInitialData(normalized);
      } catch (e) {
        console.error("Error loading company:", e);
        toast((t) => (
          <CustomToast
            t={t}
            text={"Не вдалося завантажити дані компанії"}
            type={ToastTypeEnum.ERROR}
          />
        ));
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
    getResponsibleUsers();
  }, [id]);

  useEffect(() => {
    getResponsibleUsers();
  }, [responsibleContact]);

  useEffect(() => {
    if (!initialData) return;

    const currentData = {
      name,
      type,
      site,
      description,
      responsibleContact,
    };

    const isSame = JSON.stringify(currentData) === JSON.stringify(initialData);
    setIsChanged(!isSame);
  }, [name, site, description, responsibleContact, type, initialData]);

  const handleSave = async () => {
    try {
      setIsLoading(true);

      const { hasErrors } = validate(
        {
          name,
          site,
          description,
          responsibleContact,
          type,
        },
        ValidationFormsModeEnum.EDIT
      );

      if (hasErrors) return;

      const response = await authFetch(`${API_URL_COMPANY}/update-company`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: id,
          name: name,
          siteLink: site,
          contactMainEmail: responsibleContact,
          description: description,
          customerType: type,
        }),
        credentials: "include",
      });

      if (!response.ok) {
        toast((t) => (
          <CustomToast
            t={t}
            type={ToastTypeEnum.WARNING}
            text={"Перевірте коректність введення даних!"}
          />
        ));
        return;
      }
      toast((t) => (
        <CustomToast
          t={t}
          type={ToastTypeEnum.SUCCESS}
          text={"Дані введені коректно, компанія відредагована!"}
        />
      ));
      setTimeout(() => {
        navigate("/companies/main");
      }, 300);
    } catch (error) {
      console.error("Fetch error:", error);
      toast((t) => (
        <CustomToast
          t={t}
          text={"Упс, щось пішло не так\nПроблема з сервером."}
          type={ToastTypeEnum.ERROR}
        />
      ));
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 150);
    }
  };

  return (
    <AppLayout
      className="d-flex flex-column align-items-center"
      blockType={"item-form"}
      loaderState={isLoading}
    >
      <Headline
        headline={HeadlineTypeEnum.COMPANIES}
        theme={ThemeTypeEnum.LIGHT}
        btn_text="Повернутися до Компаній"
        btn_link="/companies/main"
      />
      <MainBody className="align-items-stretch">
        <BodyDiv
          data-class="add-block"
          className="d-flex flex-column align-items-center"
        >
          <CaptionText>Редагувати основні дані компанії</CaptionText>
          <div className="w-100">            
            <Input
              attribute="nameOfCompany"
              value={name}
              setValue={setName}
              errorText={errors.name}
              label="Назва"
              placeholder="Введіть назву компанії"
            />
            <Input
              attribute="website"
              value={site}
              setValue={setSite}
              errorText={errors.site}
              label="Сайт компанії"
              placeholder="https://testcompany.com"
            />
            <Input
              attribute="description"
              value={description}
              setValue={setDescription}
              errorText={""}
              label="Опис"
              placeholder="Напишіть трішки інформації про компанію"
            />
          </div>
        </BodyDiv>
        <BodyDiv
          data-class="add-block-other"
        >
          <span className="w-100 d-flex flex-column align-items-center">
            <CaptionText>Змінити контакт представника</CaptionText>
            <Input
              attribute="contact"
              value={responsibleContact}
              setValue={setResponsibleContact}
              errorText={""}
              label=""
              contactsArr={filterResponsible}
              placeholder="Введіть пошту / ім’я"
            />
          </span>
          <span className="w-100 d-flex flex-column align-items-center">
            <CaptionText>Змінити тип компанії</CaptionText>
            <GeneralItemBlock>
              {Object.values(TypeClientEnum).map((item: string) => {
                const isActive: boolean = type === item;
                return (
                  <Button
                    key={item}
                    bgcolor={
                      isActive
                        ? typeClientObj[item as TypeClientEnum].bgColor
                        : "transparent"
                    }
                    txtcolor={
                      isActive
                        ? typeClientObj[item as TypeClientEnum].txColor
                        : COLORS["bg-text-color"]
                    }
                    brcolor={
                      isActive
                        ? typeClientObj[item as TypeClientEnum].bgColor
                        : COLORS["bg-text-color"]
                    }
                    width="100%"
                    type="large"
                    brradius="24px"
                    className=""
                    onClick={() => {
                      setType(item);
                    }}
                  >
                    <TextBody>{item as TypeClientEnum}</TextBody>
                    {isActive && (
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 32 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M28.708 8.70799L14.708 22.708C14.6151 22.8011 14.5048 22.875 14.3833 22.9254C14.2618 22.9758 14.1315 23.0018 14 23.0018C13.8685 23.0018 13.7382 22.9758 13.6167 22.9254C13.4952 22.875 13.3849 22.8011 13.292 22.708L5.29199 14.708L6.70799 13.292L14 20.586L27.294 7.29199L28.708 8.70799Z"
                          fill={
                            isActive
                              ? typeClientObj[item as TypeClientEnum].txColor
                              : "transparent"
                          }
                        />
                      </svg>
                    )}
                  </Button>
                );
              })}
            </GeneralItemBlock>
          </span>
        </BodyDiv>
      </MainBody>
      <Button
        bgcolor={COLORS.secondary1}
        txtcolor={COLORS.white}
        brcolor={"transparent"}
        width="30%"
        className="center-btn"
        brradius="24px"
        type="large"
        onClick={handleSave}
        noactive={!isChanged}
        disabled={!isChanged}
      >
        <LittleSubHeadline>Зберегти зміни</LittleSubHeadline>
      </Button>
    </AppLayout>
  );
}
